import { useEffect, useMemo, useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { Stack } from "@fluentui/react";

import styles from "./Answer.module.css";

import { AskResponse, Citation } from "../../api";
import { parseAnswer } from "./AnswerParser";
import Jassim from "../../assets/sanad.png";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import supersub from "remark-supersub";

interface Props {
  answer: AskResponse;
  onCitationClicked: (citedDocument: Citation) => void;
  isDoneProcessing?: boolean;
}

export const Answer = ({ answer, isDoneProcessing }: Props) => {
  const [isRefAccordionOpen, { toggle: toggleIsRefAccordionOpen }] =
    useBoolean(false);
  const filePathTruncationLimit = 50;

  const parsedAnswer = useMemo(() => parseAnswer(answer), [answer]);
  const [chevronIsExpanded, setChevronIsExpanded] =
    useState(isRefAccordionOpen);

  useEffect(() => {
    setChevronIsExpanded(isRefAccordionOpen);
  }, [isRefAccordionOpen]);

  const createCitationFilepath = (
    citation: Citation,
    index: number,
    truncate: boolean = false
  ) => {
    let citationFilename = "";

    if (citation.filepath && citation.chunk_id) {
      if (truncate && citation.filepath.length > filePathTruncationLimit) {
        const citationLength = citation.filepath.length;
        citationFilename = `${citation.filepath.substring(
          0,
          20
        )}...${citation.filepath.substring(citationLength - 20)} - Part ${
          parseInt(citation.chunk_id) + 1
        }`;
      } else {
        citationFilename = `${citation.filepath} - Part ${
          parseInt(citation.chunk_id) + 1
        }`;
      }
    } else if (citation.filepath && citation.reindex_id) {
      citationFilename = `${citation.filepath} - Part ${citation.reindex_id}`;
    } else {
      citationFilename = `Citation ${index}`;
    }
    return citationFilename;
  };

  return (
    <>
      <Stack className={styles.answerContainer} tabIndex={0}>
        <Stack.Item grow>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              color: "grey",
              fontSize: "10px",
            }}
          >
            <img width={32} src={Jassim} aria-hidden="true" />
            <span>AI-generated content may be incorrect</span>
          </div>
          <ReactMarkdown
            linkTarget="_blank"
            remarkPlugins={[remarkGfm, supersub]}
            children={parsedAnswer.markdownFormatText}
            className={styles.answerText}
          />
        </Stack.Item>
        {isDoneProcessing && (
          <Stack horizontal className={styles.answerFooter}>
            <Stack.Item className={styles.answerDisclaimerContainer}>
              <div className={styles.answerDisclaimer}>
                For more information, please email us at
                <a
                  className={styles.answerLink}
                  href="mailto:Service-Management@qdb.qa"
                  target="_blank"
                >
                  Service-Management@qdb.qa
                </a>
              </div>
            </Stack.Item>
          </Stack>
        )}
        {chevronIsExpanded && (
          <div
            style={{
              marginTop: 8,
              display: "flex",
              flexFlow: "wrap column",
              maxHeight: "150px",
              gap: "4px",
            }}
          ></div>
        )}
      </Stack>
    </>
  );
};
